import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  roleBased: {},
};

const rbacValue = createSlice({
  name: 'rbacValue',
  initialState,
  reducers: {
    setRbacValue: (state, action) => {
      return {...state, ...action.payload};
    },

    resetRbacValue: () => initialState,
  },
});

export const {setRbacValue, resetRbacValue} = rbacValue.actions;

export default rbacValue.reducer;
